// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-section {
  background: #fff;
  min-height: 100vh;
  padding: 40px 0;
}

.admin-header h1 {
  color: #d4af37;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.stat-card i {
  font-size: 32px;
  color: #d4af37;
}

.stat-info h3 {
  margin: 0;
  font-size: 28px;
  color: #2d2d2d;
}

.stat-info p {
  margin: 0;
  color: #666;
}

.admin-actions, .recent-activity {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.admin-actions h2, .recent-activity h2 {
  color: #2d2d2d;
  margin-bottom: 20px;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.activity-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.activity-item i {
  color: #d4af37;
  font-size: 18px;
}

.activity-content p {
  margin: 0;
  color: #2d2d2d;
}

.activity-content small {
  color: #666;
}

.error-text {
  color: #c62828;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.listing-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
}

.listing-actions {
  display: flex;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/admin.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,WAAA;AACF;;AAEA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF","sourcesContent":[".admin-section {\n  background: #fff;\n  min-height: 100vh;\n  padding: 40px 0;\n}\n\n.admin-header h1 {\n  color: #d4af37;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.stat-card {\n  background: rgba(255,255,255,0.95);\n  border-radius: 12px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1);\n}\n\n.stat-card i {\n  font-size: 32px;\n  color: #d4af37;\n}\n\n.stat-info h3 {\n  margin: 0;\n  font-size: 28px;\n  color: #2d2d2d;\n}\n\n.stat-info p {\n  margin: 0;\n  color: #666;\n}\n\n.admin-actions, .recent-activity {\n  background: rgba(255,255,255,0.95);\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.admin-actions h2, .recent-activity h2 {\n  color: #2d2d2d;\n  margin-bottom: 20px;\n}\n\n.action-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.activity-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.activity-item i {\n  color: #d4af37;\n  font-size: 18px;\n}\n\n.activity-content p {\n  margin: 0;\n  color: #2d2d2d;\n}\n\n.activity-content small {\n  color: #666;\n}\n\n.error-text {\n  color: #c62828;\n}\n\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.listing-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.listing-actions {\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
